import React from 'react'
import PropTypes from 'prop-types'

import { FormWrapper, Selection, SensorStatus } from 'components';

import { Form, Modal, Header, TransitionablePortal } from 'semantic-ui-react'

import { API } from 'services';
import { EnumSensorStatus } from 'enums';

class ModalEditSensor extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit
        },
        cancel: {
          name: "Annuler",
          callback: this.props.onClose
        }
      }
    };
  }

  handleSubmit(data, onSucess, onError) {

    API.put(`/sensors/${this.props.sensor.mac_address}`, data)
      .then((response) => {
        this.props.onClose(response.data);
      })
      .catch((error) => {
        onError(API.violations(error));
      });
  }

  getStatuses() {

    return EnumSensorStatus.values.map((value) => {
      return {
        key: value,
        value: value,
        text: (
          <SensorStatus status={value} />
        )
      };
    });
  }

  render() {

    const { sensor } = this.props;

    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal open size="small">
          <Header icon="edit" content="Modification capteur" />
          <Modal.Content>

            <FormWrapper actions={this.state.actions}>

              {/* Delivery date */}
              <Form.Field>
                <label htmlFor="inputStatus">État</label>
                <Selection id="inputStatus" name="status" value={sensor.status} options={this.getStatuses()} placeholder="Question" clearable search={false} />

              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalEditSensor.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default ModalEditSensor;
